import React from 'react';
import { Card, Tag } from 'antd';
import {
  BarChartOutlined,
  FileSearchOutlined,
  QuestionCircleOutlined,
  ThunderboltOutlined,
} from '@ant-design/icons';
import styles from '../../styles/chatV2.module.css';

const SuggestionCards = ({ suggestions = [], onSelectSuggestion }) => {
  const getCategoryIcon = (category) => {
    switch (category) {
      case 'analytics':
        return <BarChartOutlined />;
      case 'search':
        return <FileSearchOutlined />;
      case 'quick':
        return <ThunderboltOutlined />;
      default:
        return <QuestionCircleOutlined />;
    }
  };

  const getCategoryColor = (category) => {
    switch (category) {
      case 'analytics':
        return 'blue';
      case 'search':
        return 'green';
      case 'quick':
        return 'orange';
      default:
        return 'default';
    }
  };

  return (
    <div className={styles.suggestionCardsContainer}>
      <div className={styles.suggestionCardsGrid}>
        {suggestions.map((suggestion, index) => (
          <Card
            key={index}
            hoverable
            className={styles.suggestionCard}
            onClick={() => onSelectSuggestion(suggestion.text)}
          >
            <div className={styles.suggestionCardContent}>
              <div className={styles.suggestionCardIcon}>
                {getCategoryIcon(suggestion.category)}
              </div>
              <div className={styles.suggestionCardText}>
                {suggestion.text}
              </div>
              {suggestion.category && (
                <Tag
                  color={getCategoryColor(suggestion.category)}
                  className={styles.suggestionCardTag}
                >
                  {suggestion.category}
                </Tag>
              )}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default SuggestionCards;
